import * as React from 'react'
import { useMemo } from 'react'

import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'

import {
  addOpportunityTargetPestsSection,
  entityTargetPests,
} from '@user/components/Settings/EntityFormSettings'
import { FormSectionTitle } from '../../FormComponents/FormSectionTitle'
import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { TargetPestSelect } from '../../FormComponents/TargetPestSelect/TargetPestSelect'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { DensityType } from '../../../typings'

type Props = {
  hideOptional: boolean
}
export function TargetPestSection(props: Props) {
  const { hideOptional } = props
  const tidalThemeActive = useTidalThemeActive()

  const settings = useSelector(selectAllEntityFormSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [requiredTargetPests, showTargetPests] = entitySettingsMap.get(
    entityTargetPests,
  ) ?? [false, true]

  const showSection: boolean = useMemo(
    () =>
      !!settings.find(
        (setting) =>
          setting.sectionId === addOpportunityTargetPestsSection &&
          (setting.required || (setting.active && !hideOptional)),
      ),
    [hideOptional, settings],
  )

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  return showSection ? (
    <Stack gap={2} pb={4}>
      <FormSectionTitle>Target Pest(s)</FormSectionTitle>
      <TargetPestSelect
        density={density}
        name="targetPests"
        required={requiredTargetPests}
        show={showTargetPests}
      />
    </Stack>
  ) : null
}
